import { usePageContext } from '#app/hooks/usePageContext.js';

export const useRouteParameter = (parameterName: string): null | string => {
  const pageContext = usePageContext();

  const value = pageContext.routeParams[parameterName];

  if (typeof value === 'string' && value) {
    return value;
  }

  return null;
};
